/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './content-group';
import './content-group-copy';
import './content-group-heading';
import './content-group-paragraph';
import '../cta/index';
